import {
	SET_END_DATE, SET_END_TIME, SET_START_DATE, SET_START_TIME
} from "./DateTimePickerActionsType";

const actions = {
	[SET_START_DATE]: ({ commit }, date) =>
	{
		commit(SET_START_DATE, date);
	},
	[SET_START_TIME]: ({ commit }, time) =>
	{
		commit(SET_START_TIME, time);
	},
	[SET_END_DATE]: ({ commit }, date) =>
	{
		commit(SET_END_DATE, date);
	},
	[SET_END_TIME]: ({ commit }, time) =>
	{
		commit(SET_END_TIME, time);
	},
};

export default { actions };